import { useState, useEffect, useCallback } from "react";
import { CustomerTableData } from "../types/customerTypes";
import api from "../../../../../features/auth/axiosConfig";

export const useCustomerData = (showDeleted: boolean, searchTerm: string, page: number, rowsPerPage: number) => {
  const [customerData, setCustomerData] = useState<CustomerTableData>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>("");

  const fetchCustomers = useCallback(async () => {
    try {
      setLoading(true);
      setError("");
      const pageNumber = page + 1;
      const pageSize = rowsPerPage === -1 ? 1000 : rowsPerPage;
      let url = `/app/v1/pos/customer?include_deleted=${showDeleted}&pageNumber=${pageNumber}&pageSize=${pageSize}`;
      // Add search term if provided
      if (searchTerm.trim()) {
        url += `&searchBy=${encodeURIComponent(searchTerm.trim())}`;
      }

      const response = await api.get(url);

      if (response.data) {
        setCustomerData(response.data);
      }
    } catch (err: any) {
      const errorMessage = err.response?.data?.message || "Failed to fetch customer data";
      setError(errorMessage);
      console.error("Error fetching customer data:", err);
    } finally {
      setLoading(false);
    }
  }, [showDeleted, searchTerm, page, rowsPerPage]);

  useEffect(() => {
    fetchCustomers();
  }, [fetchCustomers]);

  return { customerData, loading, error, refetch: fetchCustomers };
};
